(function () {
  'use strict';

  var SELECTOR = {
    root: '[data-clpc-calc]',
    tab: '[data-clpc-qty]',
    without: '[data-clpc-without]',
    withPrice: '[data-clpc-with]',
    save: '[data-clpc-save]',
  };

  function amount(raw) {
    var n = parseFloat(String(raw || '').replace(/[^\d.]/g, ''));
    return isFinite(n) ? n : NaN;
  }

  // Integer pennies so 39.90 × 3 prints 119.70, not 119.69999
  function pennies(value) {
    return Math.round(value * 100);
  }

  // data-whole-pounds (setting "Drop .00"): £30 instead of £30.00
  function format(p, currency, wholePounds) {
    if (wholePounds && p % 100 === 0) return currency + p / 100;
    return currency + (p / 100).toFixed(2);
  }

  function render(root, qty) {
    var currency = root.getAttribute('data-currency') || '£';
    var withoutBase = amount(root.getAttribute('data-without-base'));
    var withBase = amount(root.getAttribute('data-with-base'));
    var wholePounds = root.hasAttribute('data-whole-pounds');
    if (isNaN(withoutBase) || isNaN(withBase)) return;

    var withoutP = pennies(withoutBase) * qty;
    var withP = pennies(withBase) * qty;
    var map = [
      [SELECTOR.without, withoutP],
      [SELECTOR.withPrice, withP],
      [SELECTOR.save, withoutP - withP],
    ];
    map.forEach(function (pair) {
      var el = root.querySelector(pair[0]);
      if (el) el.textContent = format(pair[1], currency, wholePounds);
    });
  }

  function onClick(event) {
    var tab = event.target.closest(SELECTOR.tab);
    if (!tab) return;
    var root = tab.closest(SELECTOR.root);
    if (!root) return;
    root.querySelectorAll(SELECTOR.tab).forEach(function (t) {
      var on = t === tab;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    render(root, parseInt(tab.getAttribute('data-clpc-qty'), 10) || 1);
  }

  if (window.__clpcCalcBound) return;
  window.__clpcCalcBound = true;
  // One delegated listener: works for sections re-rendered by the theme editor
  document.addEventListener('click', onClick);
})();
